module.exports = __webpack_public_path__ + "static/media/logo_WeChat Pay.b8245482.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/logo_WeChat Pay.png
// module id = 143
// module chunks = 4